import { TimelineQuestionIcon } from './TimelineQuestionIcon';

/**
 * author: Austin Andrews
 * id 92637DDF-E9A3-43E1-986D-DA5DE7FA8CDE
 * name timeline-question
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timeline-question.svg
 * tags
 */
export const TimelineHelpIcon = TimelineQuestionIcon;
export default TimelineHelpIcon